import type { Star } from "../store/types";

export const generateStars = (count: number): Star[] => {
  const stars: Star[] = [];

  for (let i = 0; i < count; i++) {
    stars.push({
      id: i,
      style: {
        position: "absolute",
        top: Math.random() * 100 + "%",
        left: Math.random() * 100 + "%",
        transform: `translateY(-50%) scale(${Math.random() * 1.5 + 0.2})`,
      },
    });
  }

  return stars;
};
